import React from "react";
import { CheckCircle2, Clock, AlertCircle, Minus, XCircle } from "lucide-react";
import { STATUS_CONFIG } from "@/lib/format";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const ICONS = { check: CheckCircle2, clock: Clock, alert: AlertCircle, minus: Minus, x: XCircle };
const EDIT_OPTIONS = ["COMPLETED", "IN_PROGRESS", "PENDING", "NOT_APPLICABLE"];

export function StatusCell({ status, onChange, readOnly, testid, compact }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.PENDING;
  const Icon = ICONS[cfg.icon] || AlertCircle;
  const dim = compact ? "h-7 w-7" : "h-8 w-8";
  const isize = compact ? 15 : 17;
  const trigger = (
    <button
      data-testid={testid}
      disabled={readOnly}
      className={`inline-flex items-center justify-center ${dim} rounded-lg ${cfg.bg} ring-1 ${cfg.ring} ${readOnly ? "" : "hover:scale-110"} transition-transform`}
      title={cfg.label}
    >
      <Icon size={isize} className={cfg.color} />
    </button>
  );
  if (readOnly) return trigger;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="bg-white w-44">
        {EDIT_OPTIONS.map((opt) => {
          const oc = STATUS_CONFIG[opt];
          const OIcon = ICONS[oc.icon] || AlertCircle;
          return (
            <DropdownMenuItem key={opt} data-testid={`status-option-${opt}`} onClick={() => onChange(opt)} className="gap-2 cursor-pointer">
              <OIcon size={15} className={oc.color} /> {oc.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
